import React from 'react';
import GlobalHeader from '../../../GlobalComponent/GlobalHeader';

export default function Header({ toggleSidebar }) {
  return (
    <>
      <GlobalHeader toggleSidebar={toggleSidebar} />
    </>
  )
}
